export enum URL_TYPE {
    normal = 0,
    resourceURL = 1
}